import { render, staticRenderFns } from "./TiersVue.vue?vue&type=template&id=a90b1b78&"
import script from "./TiersVue.vue?vue&type=script&lang=js&"
export * from "./TiersVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports